import React from 'react';

/**
 * contactListId списков контактов из настроек кампаний, привязанных к этой цепочке (один согласованный набор).
 * Если задан непустой массив — блоки SMS/Viber/Email не показывают выбор списка на уровне узла.
 * `null` — нет привязки или конфликт наборов между кампаниями.
 */
export const MailingFlowCampaignSubscriberListContext = React.createContext<readonly string[] | null>(null);

export function useMailingFlowCampaignSubscriberListIds(): readonly string[] | null {
  return React.useContext(MailingFlowCampaignSubscriberListContext);
}
